//@flow
import { businessUnitApi } from 'common/middleware/api';

import { injectError } from 'common/redux/actions/error';
import { ApiError } from 'common/modules/api';

import type { Dispatch } from 'redux';

export type BusinessUnitResponse = {
    businessUnits: Array<Object>
};

export class IntlActions {
    static FETCH_BU_START = 'FETCH_BU_START';
    static FETCH_BU_SUCCESS = 'FETCH_BU_SUCCESS';
    static FETCH_BU_ERROR = 'FETCH_BU_ERROR';
    static SET_SELECTED_BU = 'SET_SELECTED_BU';

    static setSelectedBU({
        clientId,
        personnelId,
        selectedBU
    }: {
        clientId: string,
        personnelId: string,
        selectedBU: ?string
    }) {
        return {
            type: IntlActions.SET_SELECTED_BU,
            payload: {
                clientId,
                personnelId,
                selectedBU
            }
        };
    }

    static fetchBusinessUnitStart({ params }) {
        return {
            type: IntlActions.FETCH_BU_START,
            params
        };
    }

    static fetchBusinessUnitSuccess({ params, businessUnits }) {
        return {
            type: IntlActions.FETCH_BU_SUCCESS,
            params,
            businessUnits
        };
    }

    static fetchBusinessUnitError({ params }) {
        return {
            type: IntlActions.FETCH_BU_ERROR,
            params
        };
    }

    static fetchBusinessUnits({ clientId }) {
        return (dispatch: Dispatch<*>) => {
            const params = {
                clientId
            };
            dispatch(IntlActions.fetchBusinessUnitStart({ params }));
            return businessUnitApi
                .fetch(params)
                .then((businessUnits: BusinessUnitResponse) => {
                    dispatch(
                        IntlActions.fetchBusinessUnitSuccess({
                            params,
                            businessUnits
                        })
                    );
                })
                .catch(error => {
                    dispatch(IntlActions.fetchBusinessUnitError({ params }));
                    if (error instanceof ApiError) {
                        dispatch(injectError(error));
                    } else {
                        throw error;
                    }
                });
        };
    }
}
